import { ThemeProvider, createTheme } from '@mui/material/styles';

// import './fonts.css';

export default createTheme({
	palette: {
		primary: {
			light: '#42a5f5',
			main: 'rgba(0,130,240,1)',
			dark: '#1565c0',
			contrastText: '#fff',
		},
		secondary: {
			light: '#ff7961',
			main: '#f44336',
			dark: '#ba000d',
			contrastText: '#000',
		},
	},
	typography: {
		fontSize: 20,
		// fontFamily: [
		// 	"Roboto"
		//   ].join(','),
		button: {
			textTransform: 'none' // prevent capitalize
		}
	},
	
	transitions: {
        duration: {
            enteringScreen: 0,
            leavingScreen: 0,
        }
    },
	
	components: {
		MuiSelect: {
			styleOverrides: {
				root: {
					height: "50px",
				}
			},
		},

		MuiList: {
			styleOverrides: {
				root: {
					// marginTop: "20px",
					// marginBottom: "20px"
				}
			}
		},
		
		MuiBottomNavigationAction: {
			styleOverrides: {
				label: {
					fontSize: "12px"
				}
			}
		},
		
		MuiButtonBase: {
			
			defaultProps: {
				disableRipple: true,
				// focusRipple: false,
				// disableTouchRipple: true,
				
			},
			styleOverrides: {
				root:{
					
				}
			},
			
			
		},
		
		MuiMenuItem: {
			styleOverrides: {
				root:{
					":hover": {
						backgroundColor: "rgba(1,1,1,0.08)"
					}, 
					":active": {
						backgroundColor: "rgba(1,1,1,0.14)",
					},
				}
			}
		},
		
		
		MuiButton: {
			styleOverrides: {
				root:{
					boxShadow: "0px 0px",
					transition: "background-color 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
					minWidth: 0,
					[':hover']: {
						// backgroundColor: theme.palette.primary.main,
						boxShadow: "0px 0px",
					},
					[":active"]: {
						backgroundColor: "#1254a1",
						boxShadow: "0px 0px",
					},
					[":focus"]: {
						boxShadow: "0px 0px",
					}
					/*
					['.MuiTouchRipple-rippleVisible']: {
						animationDuration: '0ms',
					},
					['.MuiTouchRipple-ripplePulsate']: {
						animationDuration: '0ms',
					},
					['.MuiTouchRipple-childLeaving']: {
						animationDuration: '0ms',
					},
					['.MuiTouchRipple-childPulsate']: {
						animationDuration: '0ms',
					},
					['.MuiTouchRipple-ripple']: {
						animationDuration: '0ms',
					},
					['.MuiTouchRipple-child']: {
						animationDuration: '0ms',
						animationDelay: '0ms',
					},*/
				}
            },
			variants: [
				{
					props: { variant: 'text' },
					style: {
						"@media (hover: hover)": { // prevent touch causing hover effect remain
							":hover": {
								backgroundColor: "rgba(1,1,1,0.1)"
							}
						},
						":active": {
							backgroundColor: "rgba(1,1,1,0.2)",
						},
					},
				},
				{
					props: { variant: 'outlined' },
					style: {
						"@media (hover: hover)": { // prevent touch causing hover effect remain
							":hover": {
								backgroundColor: "rgba(0,130,240,0.1)"
							}
						},
						":active": {
							backgroundColor: "rgba(0,130,240,0.2)",
						},
					},
				}
			]
		},
		
		MuiIconButton: {
			// defaultProps: {
				// disableTouchRipple: true
			// }
            styleOverrides: {
				root:{
					transition: "background-color 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
					/*
					['.MuiTouchRipple-rippleVisible']: {
						animationDuration: '200ms',
					},
					['.MuiTouchRipple-childLeaving']: {
						animationDuration: '500ms',
					}*/
					// ":hover": {
						// backgroundColor: "rgba(1,1,1,0.2)"
					// }, 
					"@media (hover: hover)": { // prevent touch causing hover effect remain
						":hover": {
							backgroundColor: "rgba(1,1,1,0.1)"
						}
					},
					":active": {
						backgroundColor: "rgba(1,1,1,0.2)",
					},

					
				}
            }
        },
		
		MuiToolbar: {
            styleOverrides: {
                dense: {
                    height: 60,
                    minHeight: 60
                }
            }
        },

		MuiMenu: {
			defaultProps: {
				transitionDuration: 0,
			}
		},
		
		/*
		MuiDialog: {
			styleOverrides: {
				paper: {
					backgroundColor:"rgba(255,255,255,0.85)",
					backdropFilter: "blur(5px)"
				}
			}
		},
		
		MuiMenu: {
			styleOverrides: {
				paper: {
					backgroundColor:"rgba(255,255,255,0.85)",
					backdropFilter: "blur(5px)"
				}
			}
		},
		
		MuiBackdrop: {
			styleOverrides: {
				root: {
					backgroundColor:"rgba(255,255,255,0.0)"
				},
			}
		}
		*/

	}
	
	
});